import authFetch from './fetch';
import { getQueryParams, makeRequest } from './utils';

export const routes = {

  templatesPath: () => '/api/CMSv2/WarehouseInstructions/templates',
  templatesGridPath: () => '/api/CMSv2/WarehouseInstructions/grid',
  templatesSearchPropertiesPath: () => '/api/CMSv2/WarehouseInstructions/SearchProperties',
  templatesRestorePath: (id) => `/api/CMSv2/WarehouseInstructions/${id}/restore`,
  templatePath: (id) => `/api/CMSv2/WarehouseInstructions/template/${id}`,
  upsertTemplatePath: () => '/api/CMSv2/WarehouseInstructions/template',
  upsertInstructionPath: () => '/api/CMSv2/WarehouseInstructions',
  getInstructionByProNumberPath: (proNumber) => `/api/CMSv2/WarehouseInstructions/byOrderProNumber/${proNumber}`,
  templatesAuditPath: (id) => `/api/CMSv2/WarehouseInstructions/${id}/Audits`,
  templatesAuditUsersPath: (id) => `/api/CMSv2/WarehouseInstructions/${id}/Audits/Users`,
  templatesAuditPropertiesPath: (id) => `/api/CMSv2/WarehouseInstructions/${id}/Audits/Properties`,
};

export const getTemplatesGrid = (params) => makeRequest(authFetch.get(`${routes.templatesGridPath()}${getQueryParams(params)}`));
export const getTemplates = () => makeRequest(authFetch.get(routes.templatesPath()));
export const getTemplate = (id) => makeRequest(authFetch.get(routes.templatePath(id)));
export const deleteTemplate = (id) => makeRequest(authFetch.delete(routes.templatePath(id)));
export const upsertTemplate = (template) => makeRequest(authFetch.put(routes.upsertTemplatePath(), template));
export const upsertInstruction = (instruction) => makeRequest(authFetch.put(routes.upsertInstructionPath(), instruction));
export const getInstructionByProNumber = (proNumber) => makeRequest(authFetch.get(routes.getInstructionByProNumberPath(proNumber)));
export const getTemplatesSearchProperties = () => makeRequest(authFetch.get(routes.templatesSearchPropertiesPath()));
export const restoreWarehouseInstruction = (id) => makeRequest(authFetch.patch(routes.templatesRestorePath(id)));
export const getWarehouseInstructionsTemplatesAudits = async (id, params) => makeRequest(authFetch.get(routes.templatesAuditPath(id, params)));
export const getWarehouseInstructionsTemplatesAuditUsers = (id) => makeRequest(authFetch.get(routes.templatesAuditUsersPath(id)));
export const getWarehouseInstructionsTemplatesAuditProperties = (id) => makeRequest(authFetch.get(routes.templatesAuditPropertiesPath(id)));